var _ = require('underscore');
var $ = require('jquery');

function setTitle() {
    $.ajax({
        url: RoutingS1.generate('setProductTitle'),
        type: 'POST',
        data: {
            title: $.trim($('#newTitleInput').val()),
            product_name: productSlug
        },
        success: function() {
            $('#newTitle').hide();
            $('#title').html($('#newTitleInput').val()).show();
            $('input#order_name').val($.trim($('#newTitleInput').val()));
        }
    });
    return false;
}

$(document).ready(function() {
    if (!_.isUndefined(titleChangeable) && titleChangeable) {
        $('#title.title-is-changeable').on('click', function() {
            $(this).hide();

            // set value
            $('#newTitleInput').val($.trim($(this).html()));

            // shows container
            $('#newTitle').show();

            //sets focus
            $('#newTitleInput').focus();
        });

        $("#newTitleInput").bind("keypress", function(e) {
            if (e.keyCode == 13) {
                return setTitle();
            }
        });

        $('#acceptTitle').on('click', function() {
            setTitle();
        });

        $('#cancelTitle').on('click', function() {
            $('#newTitle').hide();
            $('#title').show();
        });
    }

    $("button#addToBasket, button#orderNow, button#addNewWizard, button#openGallery")
        .on('click', function(e) {
            var targetAction = $(this).attr('id');
            $('input#targetAction').attr('value', targetAction);
        })
    ;
    if (preview) {
        $('.mini-switch-replace').unbind('click');
        $('.form-fieldset input, .form-fieldset select, .form-fieldset textarea').attr({'readonly': 'readonly', 'disabled': 'disabled'});
        $('.form-fieldset input, .form-fieldset textarea').attr('readonly', 'readonly');
        $('.form-fieldset select').attr('disabled', 'disabled');
    }
});

